import React from "react";

import { createStyles, makeStyles } from "@material-ui/core/styles";

import { ACCENT_BLUE, ALMOST_WHITE, DARK_CORAL, WHITE } from "constants/colors";
import { TextField } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({

    input: {
      backgroundColor: "#232933",
      borderRadius: "4px",
      fontSize: "14px",
      width: "100%",
      margin: "4px 0",


    },
    ccssLabel: {
      color: '#CFD9E6',
    },
    cssFocused: {
      color: '#CFD9E6 !important'
    },
    cssOutlinedInput: {
      color: "white",
      outline: "0px",
      '&:hover:not($disabled):before': {
        borderBottom: '2px solid #90caf9'
      },
      '&::after': {
        borderBottom: '2px solid #90caf9'
      },
      '&::before': {
        borderBottom: '2px solid #596c8d'
      },


    },
  })
);

type Props = {
  id: string;
  name: string;
  type: string;
  change: (
    eventOrPath: string | React.ChangeEvent<any>
  ) => void | ((eventOrTextValue: string | React.ChangeEvent<any>) => void);
  onKeyDown: (event: React.KeyboardEvent<any>) => void;
  value: string;
  label: string
};

const Input = ({ id, name, type, change, onKeyDown, value, label }: Props) => {
  const classes = useStyles();

  return (
    <TextField
      type={type}
      value={value}
      className={classes.input}
      id={id}
      name={name}
      label={label}
      variant="filled"
      size="small"
      autoComplete="off"
      onChange={change}
      onKeyDown={onKeyDown}
      InputLabelProps={{
        classes: {
          root: classes.ccssLabel,
          focused: classes.cssFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.cssOutlinedInput,
        }
      }}

    />
  );
};

export default Input;
